import FetchStatus from "@/constants/fetch-status/FetchStatus";
import i18n from "@/i18n";

const GeneratorShaftStateModel = () =>
{
	const model = {
		status:             FetchStatus.Init,
		operatingRange:     0,
		successMessage:     "",
		errorMessage:       "",
		operatingRange:     0,
		orderChartData:     [],
		frequencyChartData: [],
		orderLayout:        {},
		frequencyLayout:    {},
	};
	return model;
};

const GeneratorShaftUnbalanceLayoutModel = () =>
{
	const layout = {
		annotations:   [],
		paper_bgcolor: "rgba(0,0,0,0)",
		plot_bgcolor:  "rgba(0,0,0,0)",
		color:         "",
		showlegend:    true,
		shapes:        [],
		legend:        {
			x:           0,
			y:           1.2,
			orientation: "h",
			font:        {
				family: "Segoe UI",
				size:   18,
				color:  "",
			},
		},
		margin: {
			l:   70,
			r:   40,
			b:   50,
			t:   0,
			pad: 0,
		},
		xaxis: { title: i18n.t("Labels.XAxisName") },
		yaxis: { title: i18n.t("Labels.YAxisNameMms") },
	};
	return layout;
};

export default { GeneratorShaftStateModel, GeneratorShaftUnbalanceLayoutModel };